import { match } from "ts-pattern";
import type { CogOutputSchema, CogOutputValue } from "../../types";
import { isImageUrl } from "./util";

export function PixelateImagesOutput({
  output,
  schema,
}: {
  output: CogOutputValue | null;
  schema: CogOutputSchema;
}) {
  if (output == null) {
    return null;
  }

  return match(schema)
    .with({ type: "string", format: "uri" }, () => {
      if (typeof output === "string" && isImageUrl(output)) {
        return <PixelatedImage url={output} />;
      }
      return null;
    })
    .with({ type: "array", items: { type: "string", format: "uri" } }, () => {
      if (Array.isArray(output)) {
        return (
          <div className="flex flex-col space-y-2">
            {output.map((url, index) => {
              if (typeof url === "string" && isImageUrl(url)) {
                return <PixelatedImage key={index} url={url} />;
              }
              return null;
            })}
          </div>
        );
      }
      return null;
    })
    .otherwise(() => null);
}

function PixelatedImage({ url }: { url: string }) {
  if (url.startsWith("data:")) {
    return <code>(not stored)</code>;
  }

  return (
    <a
      href={url}
      rel="noreferrer"
      target="_blank"
      className="inline-flex flex-col"
    >
      <img
        src={url}
        alt=""
        className="max-w-full"
        style={{ imageRendering: "pixelated" }}
      />
    </a>
  );
}

export default PixelateImagesOutput;
